<template>
  <div
    id="ResearchDevelopmentBulletinBoard"
    class="ResearchDevelopmentBulletinBoard"
  >
    <div class="floor1">
      <c-block-box title="TV端系统" class="floor-item1">
        <div class="floor-item1-wrap">
          <div class="item-childe-item1">
            <div class="left-wrap">
              <div class="lists-items">
                <div
                  class="item"
                  v-for="(item, index) in actoveTrendLists"
                  :key="index"
                >
                  <BoxItemWrap
                    v-for="itemNext in item"
                    class="item-content"
                    :item="itemNext"
                    :key="itemNext.name"
                  ></BoxItemWrap>
                </div>
              </div>
            </div>
          </div>
          <div class="item-childe-item2">
            <p class="font-size-text1 box-item-title">新增激活设备漏斗</p>
            <DomeEchartWrap ref="ActiveTrend" id="ActiveTrend"></DomeEchartWrap>
          </div>
          <div class="item-childe-item3">
            <p class="font-size-text1 box-item-title">联网&激活分析</p>
            <div class="item3-wrap">
              <div class="item3-left-wrap">
                <BoxItemWrap
                  v-for="item in NetworkActivationAnalysisLists"
                  :item="item"
                  :show-super="false"
                  :key="item.name"
                ></BoxItemWrap>
              </div>
              <div class="NetworkActivationAnalysis-wrap">
                <DomeEchartWrap
                  ref="NetworkActivationAnalysis"
                  id="NetworkActivationAnalysis"
                ></DomeEchartWrap>
              </div>
            </div>
          </div>
          <div class="item-childe-item4">
            <p class="font-size-text1 box-item-title">各系统版本活跃占比</p>
            <DomeEchartWrap
              ref="ActiveProportionEachSystemVersion"
              id="ActiveProportionEachSystemVersion"
            ></DomeEchartWrap>
          </div>
        </div>
      </c-block-box>
      <c-block-box title="联动屏" class="floor-item2" icon>
        <div class="floor-item2-wrap">
          <div class="left-wrap">
            <div
              class="item"
              v-for="(item, index) in liandongLists"
              :key="index"
            >
              <BoxItemWrap
                v-for="itemNext in item"
                class="item-content"
                :item="itemNext"
                :show-super="false"
                :key="itemNext.name"
              ></BoxItemWrap>
            </div>
          </div>
          <div class="right-wrap">
            <div class="liandong1-wrap">
              <DomeEchartWrap
                ref="Liandongping1"
                id="liandongping1"
              ></DomeEchartWrap>
            </div>
            <div class="liandong2-wrap">
              <DomeEchartWrap
                ref="Liandongping2"
                id="liandongping2"
              ></DomeEchartWrap>
            </div>
          </div>
        </div>
      </c-block-box>
    </div>

    <div class="floor2">
      <c-block-box title="服务" class="floor2-item1">
        <div class="floor2-item1-wrap">
          <div class="item">
            <div class="item-left">
              <BoxItemWrap
                v-for="item in AccountServiceApplicationUpgrade.first"
                :item="item"
                :key="item.name"
                :show-super="false"
              ></BoxItemWrap>
            </div>
            <div class="item-right">
              <DomeEchartWrap
                ref="AccountServiceApplicationUpgrade1"
                id="AccountServiceApplicationUpgrade1"
              ></DomeEchartWrap>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <BoxItemWrap
                v-for="item in AccountServiceApplicationUpgrade.second"
                :item="item"
                :key="item.name"
                :show-super="false"
              ></BoxItemWrap>
            </div>
            <div class="item-right">
              <DomeEchartWrap
                ref="AccountServiceApplicationUpgrade2"
                id="AccountServiceApplicationUpgrade2"
              ></DomeEchartWrap>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <BoxItemWrap
                v-for="item in AccountServiceApplicationUpgrade.three"
                :item="item"
                :key="item.name"
                :show-super="false"
              ></BoxItemWrap>
            </div>
            <div class="item-right">
              <DomeEchartWrap
                ref="AccountServiceApplicationUpgrade3"
                id="AccountServiceApplicationUpgrade3"
              ></DomeEchartWrap>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <BoxItemWrap
                v-for="item in AccountServiceApplicationUpgrade.four"
                :item="item"
                :key="item.name"
                :show-super="false"
              ></BoxItemWrap>
            </div>
            <div class="item-right">
              <DomeEchartWrap
                ref="AccountServiceApplicationUpgrade4"
                id="AccountServiceApplicationUpgrade4"
              ></DomeEchartWrap>
            </div>
          </div>
        </div>
      </c-block-box>
      <c-block-box title="终端分布与饱和" class="floor2-item2">
        <div class="floor2-item2-wrap">
          <div class="f2-item2-left">
            <div class="lists-wrap">
              <div
                class="item"
                v-for="(item, index) in ChinaMapLists"
                :key="index"
              >
                <BoxItemWrap
                  v-for="itemNext in item"
                  :item="itemNext"
                  :key="itemNext.name"
                  :show-super="false"
                ></BoxItemWrap>
              </div>
            </div>
          </div>
          <div class="f2-item2-right">
            <DomeEchartWrap ref="ChinaMap" id="ChinaMap"></DomeEchartWrap>
          </div>
        </div>
      </c-block-box>
      <c-block-box title="能力云30日指标" class="floor2-item3">
        <div class="floor2-item3-wrap">
          <div class="item">
            <div class="f2-item3-left">
              <div class="item">
                <span class="f2-item3-left-title">Pass</span>
                <div class="content">
                  <BoxItemWrap
                    v-for="item in PassLists"
                    :item="item"
                    :key="item.name"
                    :show-super="false"
                  ></BoxItemWrap>
                </div>
              </div>
            </div>
            <div class="f2-item3-right">
              <DomeEchartWrap ref="PaaS" id="PaaS"></DomeEchartWrap>
            </div>
          </div>
          <div class="item">
            <div class="f2-item3-left">
              <div class="item">
                <span class="f2-item3-left-title">标签维度</span>
                <!-- <div class="content">
                  <BoxItemWrap
                    v-for="item in AccountService"
                    :item="item"
                    :key="item.name"
                    :show-super="false"
                  ></BoxItemWrap>
                </div> -->
              </div>
            </div>
            <div class="f2-item3-right">
              <DomeEchartWrap
                ref="AccountService"
                id="AccountService"
              ></DomeEchartWrap>
            </div>
          </div>
          <div class="item">
            <div class="f2-item3-left">
              <div class="item">
                <span class="f2-item3-left-title">极光引擎</span>
                <div class="content">
                  <BoxItemWrap
                    v-for="item in AuroraEngine"
                    :item="item"
                    :key="item.name"
                    :show-super="false"
                  ></BoxItemWrap>
                </div>
              </div>
            </div>
            <div class="f2-item3-right">
              <DomeEchartWrap
                ref="AuroraEngine"
                id="AuroraEngine"
              ></DomeEchartWrap>
            </div>
          </div>
          <div class="item">
            <div class="f2-item3-left">
              <div class="item">
                <span class="f2-item3-left-title">标签用量</span>
                <!-- <div class="content">
                  <BoxItemWrap
                    v-for="item in LifeAssistant"
                    :item="item"
                    :key="item.name"
                    :show-super="false"
                  ></BoxItemWrap>
                </div> -->
              </div>
            </div>
            <div class="f2-item3-right">
              <DomeEchartWrap
                ref="LifeAssistant"
                id="LifeAssistant"
              ></DomeEchartWrap>
            </div>
          </div>
        </div>
      </c-block-box>
    </div>
    <div class="floor3">
      <c-block-box title="研发质量">
        <div class="floor3-content">
          <div class="floor3-item1-wrap">
            <div class="f3-item1-top">
              <BoxItemWrap :item="SLAdata">
                <template v-slot:superWrap>
                  <!-- <div class="f3-item1-super">
                    <span>本月新增 +0</span>
                    <span class="super-hb">环比 +0%</span>
                  </div> -->
                </template>
              </BoxItemWrap>
            </div>
            <div class="f3-item1-bot">
              <DomeEchartWrap
                ref="ResearchDevelopmentQuality"
                id="ResearchDevelopmentQuality"
              ></DomeEchartWrap>
            </div>
          </div>
          <div class="floor3-item2-wraps">
            <div class="f3-item2-item1">
              <div class="f3-item2-top">
                <BoxItemWrap
                  :item="{
                    name: '代码总行数',
                    count: totalGitCommit,
                  }"
                  :show-super="false"
                >
                </BoxItemWrap>
                <BoxItemWrap
                  :item="{
                    name: '人均代码行数',
                    count: avgGitCommit,
                  }"
                  :show-super="false"
                >
                </BoxItemWrap>
              </div>
              <div class="f3-item2-bot">
                <DomeEchartWrap
                  ref="ResearchDevelopmentQualityOther"
                  id="ResearchDevelopmentQualityOther"
                ></DomeEchartWrap>
              </div>
            </div>
            <div class="f3-item2-item2">
              <div class="f3-item2-top">
                <BoxItemWrap
                  class="f3-item2-top-bug"
                  :item="{
                    name: 'BUG率',
                    count: thisMonthBugRate,
                  }"
                  :show-super="false"
                >
                </BoxItemWrap>
              </div>
              <div class="f3-item2-bot">
                <DomeEchartWrap
                  ref="ResearchDevelopmentBug"
                  id="ResearchDevelopmentBug"
                ></DomeEchartWrap>
              </div>
            </div>
          </div>
        </div>
      </c-block-box>
      <c-block-box title="大数据平台效能" class="floor3-item3-box">
        <div class="floor3-item3-wrap">
          <div class="f3-item3-1">
            <DomeEchartWrap
              ref="DataPlatformEfficiency"
              id="DataPlatformEfficiency"
            ></DomeEchartWrap>
          </div>
          <div class="f3-item3-2">
            <DomeEchartWrap
              ref="IndexStability"
              id="IndexStability"
            ></DomeEchartWrap>
          </div>
        </div>
      </c-block-box>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
import BoxItemWrap from '@/components/ResearchDevelopmentBulletinBoard/BoxItemWrap'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import {
  ActiveTrendEchartOp,
  ActiveProportionEachSystemVersionEchartOp,
  NetworkActivationAnalysisEchartOp,
  Liandongping1EchartOp,
  Liandongping2EchartOp
} from './js/floor1'
import {
  PassEchartOp,
  AccountServiceEchartOp,
  AuroraEngineEchartOp,
  LifeAssistantEchartOp,
  AccountServiceApplicationUpgrade1EchartOp,
  AccountServiceApplicationUpgrade2EchartOp,
  AccountServiceApplicationUpgrade3EchartOp,
  AccountServiceApplicationUpgrade4EchartOp,
  ChinaMapEchartOp
} from './js/floor2'
import {
  ResearchDevelopmentQualityEchartOp,
  ResearchDevelopmentQualityOtherEchartOp,
  DataPlatformEfficiencyEchartOp,
  ResearchDevelopmentBugEchartOp,
  IndexStabilityEchartOp
} from './js/floor3'
import china from '@/assets/map/json/china.json'
import '@/assets/map/js/china.js'
export default {
  mixins: [common],
  name: 'ResearchDevelopmentBulletinBoard',
  components: {
    BoxItemWrap,
    DomeEchartWrap
  },
  props: {},
  data () {
    return {
      actoveTrendLists: [
        [
          {
            name: '终端活跃人数',
            count: 0,
            superName: '本月新增',
            superCount: 0
          },
          {
            name: '活跃率',
            count: 0,
            superName: '环比',
            superCount: 0
          }
        ],
        [
          {
            name: '系统活跃人数',
            count: 0,
            superName: '本月新增',
            superCount: 0
          },
          {
            name: '活跃率',
            count: 0,
            superName: '环比',
            superCount: 0
          }
        ],
        [
          {
            name: '业务活跃人数',
            count: 0,
            superName: '本月新增',
            superCount: 0
          },
          {
            name: '活跃率',
            count: 0,
            superName: '环比',
            superCount: 0
          }
        ]
      ],
      NetworkActivationAnalysisLists: [
        {
          name: '近30天平均有效联网',
          count: 0
        },
        {
          name: '激活设备数',
          count: 0
        },
        {
          name: '激活联网>=2次设备',
          count: 0
        }
      ],
      liandongLists: [
        [
          { name: '累计用户数', count: '9,002,827' },
          { name: '活跃用户数', count: '72,897' }
        ],
        [
          { name: '视频通话用户', count: '5,029' },
          { name: '活跃率', count: '6.90%' }
        ],
        [
          { name: '家庭看护用户', count: '12,829' },
          { name: '活跃率', count: '17.60%' }
        ],
        [
          { name: '投屏用户', count: '48,292' },
          { name: '活跃率', count: '66.25%' }
        ]
      ],
      ChinaMapLists: [
        [
          { name: '累计激活终端数', count: '57,642,949' },
          { name: '日活', count: '17,888,808' }
        ],
        [
          { name: '家庭累计覆盖', count: '57,297,091' },
          { name: '日活', count: '17,781,475' }
        ],
        [
          { name: '商业累计覆盖', count: '8,910' },
          { name: '日活', count: '973' }
        ],
        [
          { name: '办公累计覆盖', count: '637' },
          { name: '日活', count: '382' }
        ],
        [
          { name: '社区累计覆盖', count: '563' },
          { name: '日活', count: '433' }
        ]
      ],
      PassLists: [
        { name: '接入平台数', count: 0 },
        { name: '服务调用总量', count: 0 }
        // { name: '月服务调用总量', count: 0 }
      ],
      PaaSLists: [
        { name: '赋能业务平台数', count: 0 },
        { name: '服务调用总量', count: 0 }
      ],
      AccountService: [
        { name: '覆盖业务场景数', count: 0 },
        { name: '画像体系覆盖率', count: 0 }
      ],
      AuroraEngine: [
        { name: '策略总数', count: 0 },
        { name: '服务调用总量', count: 0 }
      ],
      LifeAssistant: [
        { name: '服务调用总量', count: 0 },
        { name: '7日留存率', count: 0 }
      ],
      AccountServiceApplicationUpgrade: {
        first: [
          { name: '账号服务用户数', count: '0' },
          { name: '账号服务登陆率', count: '0' }
          // { name: '账号服务用户数', count: '56,093,775' },
          // { name: '账号服务登陆率', count: '53.97%' }
        ],
        second: [{ name: '应用升级成功率', count: 0 }],
        three: [{ name: '流量转化率', count: 0 }],
        four: [{ name: '生活助手用户量', count: 0 }]
      },
      SLAdata: {
        count: 0,
        name: 'SLA',
        hb: 0,
        xz: 0
      },
      thisMonthBugRate: 0,
      totalGitCommit: 0,
      avgGitCommit: 0
    }
  },
  computed: {},
  created () {
    const yearMonth = JSON.parse(sessionStorage.getItem('toggleDate')).time
    this.$service
      .fetch({
        url: 'api/develop/dashboard',
        method: 'get',
        params: {
          month: yearMonth
        }
      })
      .then((res) => {
        let { centerServiceInfoVO, accountAppVO, abilityOSVO, distributedVO } =
          res
        this.$nextTick(() => {
          this.setCenterServiceInfoVO(centerServiceInfoVO)
          this.setNetworkLists(centerServiceInfoVO)
          this.setFloor3Data(res)
          this.setAccountServiceApplicationUpgrade(accountAppVO)
          /// 
          this.setNlyLists(abilityOSVO)
          this.setTeriBao(distributedVO)
        })
      })
      .catch((err) => {
        console.log(err)
      })
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs['Liandongping1'].setEchartOption(
        Liandongping1EchartOp({ v: this })
      )
      this.$refs['Liandongping2'].setEchartOption(
        Liandongping2EchartOp({ v: this })
      )

      // this.$refs['ChinaMap'].registerMap(china)
    })
  },
  watch: {},
  methods: {
    setFloor3Data (data = {}) {
      // floor3
      this.SLAdata.count = data?.developQualityVO?.totalSla ?? 0
      this.$refs['ResearchDevelopmentQuality'].setEchartOption(
        ResearchDevelopmentQualityEchartOp({
          v: this,
          data: data?.developQualityVO
        })
      )
      this.$refs['ResearchDevelopmentQualityOther'].setEchartOption(
        ResearchDevelopmentQualityOtherEchartOp({
          v: this,
          data: data?.developQualityVO?.gitCommitMap
        })
      )
      this.$refs['ResearchDevelopmentBug'].setEchartOption(
        ResearchDevelopmentBugEchartOp({
          v: this,
          data: data?.developQualityVO?.bugRateChartMap
        })
      )
      this.thisMonthBugRate =
        this.percentage(data?.developQualityVO?.thisMonthBugRate) + '%'
      this.totalGitCommit = this.numberSplitWithComma(
        data?.developQualityVO?.totalGitCommit
      )
      this.avgGitCommit = this.numberSplitWithComma(
        data?.developQualityVO?.avgGitCommit
      )
      // 大数据平台效能------
      this.$refs['DataPlatformEfficiency'].setEchartOption(
        DataPlatformEfficiencyEchartOp({
          v: this,
          data: data.platformEfficacyVOMap
        })
      )
      this.$refs['IndexStability'].setEchartOption(
        IndexStabilityEchartOp({ v: this, data: data.errorCountSortedMap })
      )
    },
    setCenterServiceInfoVO (data) {
      this.actoveTrendLists[0][0].count = this.numberSplitWithComma(
        data.terminalLiveCount
      )
      this.actoveTrendLists[0][0].superCount = this.numberSplitWithComma(
        data.incrTerminalLiveCount
      )
      // ------
      this.actoveTrendLists[0][1].count =
        this.percentage(data.terminalLiveRate) + '%'
      this.actoveTrendLists[0][1].superCount =
        this.percentage(data.activeHb) + '%'
      // ------
      this.actoveTrendLists[1][0].count = this.numberSplitWithComma(
        data.sysLiveCount
      )
      this.actoveTrendLists[1][0].superCount = this.numberSplitWithComma(
        data.incrSysLiveCount
      )
      // ------
      this.actoveTrendLists[1][1].count =
        this.percentage(data.sysLiveRate) + '%'
      this.actoveTrendLists[1][1].superCount =
        this.percentage(data.sysActiveHb) + '%'
      // ------
      this.actoveTrendLists[2][0].count = this.numberSplitWithComma(
        data.businessActiveCount
      )
      this.actoveTrendLists[2][0].superCount = this.numberSplitWithComma(
        data.incrBusinessActiveCount
      )
      // ------
      this.actoveTrendLists[2][1].count =
        this.percentage(data.businessActiveRate) + '%'
      this.actoveTrendLists[2][1].superCount =
        this.percentage(data.businessMRate) + '%'
      // 新增激活设备漏斗
      this.setActiveTrend(data.developFunnelVO)
      // 联网趋势
      this.setNetworkActivationAnalysis(data.newMacCountMap)
      // 系统版本占比
      this.setActiveProportionEachSystemVersion(data.versionMapList)
    },
    setNetworkLists (data) {
      this.NetworkActivationAnalysisLists[0].count = this.numberSplitWithComma(
        data.monthNetworking
      )
      this.NetworkActivationAnalysisLists[1].count = this.numberSplitWithComma(
        data.sumMac
      )
      this.NetworkActivationAnalysisLists[2].count = this.numberSplitWithComma(
        data.networkingDuplicateMac
      )
    },
    setAccountServiceApplicationUpgrade (data) {
      let {
        successCountMap,
        successRateMap,
        liveHelperCount,
        liveHelperCountMap
      } = data ?? {}
      let val = this.AccountServiceApplicationUpgrade
      val.first[0].count = this.numberSplitWithComma(data?.accountCount)
      val.first[1].count = this.percentage(data?.loginRate)
      //
      val.second[0].count = this.numberSplitWithComma(data?.successRate)
      val.four[0].count = this.numberSplitWithComma(data?.liveHelperCount)
      this.initFw({
        successCountMap,
        successRateMap,
        liveHelperCountMap
      })
    },
    initFw ({
      successCountMap = {},
      successRateMap,
      liveHelperCountMap
    }) {
      /// floor2
      this.$refs['AccountServiceApplicationUpgrade1'].setEchartOption(
        AccountServiceApplicationUpgrade1EchartOp({
          v: this,
          data: successCountMap
        })
      )
      this.$refs['AccountServiceApplicationUpgrade2'].setEchartOption(
        AccountServiceApplicationUpgrade2EchartOp({
          v: this,
          data: successRateMap
        })
      )
      this.$refs['AccountServiceApplicationUpgrade3'].setEchartOption(
        AccountServiceApplicationUpgrade3EchartOp({
          v: this,
          data: liveHelperCountMap
        })
      )
      this.$refs['AccountServiceApplicationUpgrade4'].setEchartOption(
        AccountServiceApplicationUpgrade4EchartOp({
          v: this,
          data: liveHelperCountMap
        })
      )
    },
    setNlyLists (data) {
      // 能力云30天
      let {
        tagNameList,
        tagCountList,
        serviceCallCountMap,
        serviceCount,
        callServiceCount,
        callEngineCount,
        engineCount,
        callEngineCountMap
      } = data
      // Pass
      this.$refs['PaaS'].setEchartOption(
        PassEchartOp({ v: this, data: serviceCallCountMap.callCountList })
      )
      this.PassLists[0].count = serviceCount
      this.PassLists[1].count = callServiceCount.toFixed(2) + '万'
      //
      this.$refs['AccountService'].setEchartOption(
        AccountServiceEchartOp({ v: this, data: tagNameList })
      )
      // 极光引擎
      this.$refs['AuroraEngine'].setEchartOption(
        AuroraEngineEchartOp({
          v: this,
          data: callEngineCountMap?.engineCountList
        })
      )
      this.AuroraEngine[0].count = engineCount
      this.AuroraEngine[1].count = callEngineCount.toFixed(2) + '万'
      // 标签用量
      this.$refs['LifeAssistant'].setEchartOption(
        LifeAssistantEchartOp({ v: this, data: tagCountList })
      )
    },
    setActiveTrend (val = {}) {
      let keys = ['jiHuo', 'connectNum', 'activeNum', 'newRecord']
      let names = ['新增激活用户', '设备联网用户', '主页活跃用户', '登录用户']
      let data = keys.map((item, index) => {
        let i = {
          name: names[index],
          val: val[item],
          value: (4 - index) * 25
        }
        if (index === 0) {
          i.label = { show: false }
        }
        i.percent = val[`rate${index}`]
        return i
      })
      this.$refs['ActiveTrend'].setEchartOption(
        ActiveTrendEchartOp({ v: this, data })
      )
    },
    setNetworkActivationAnalysis (val) {
      let data = {
        ...val.newMac
      }
      this.$refs['NetworkActivationAnalysis'].setEchartOption(
        NetworkActivationAnalysisEchartOp({ v: this, data })
      )
    },
    setActiveProportionEachSystemVersion (val = []) {
      let data = val.map((item) => {
        return {
          name: item.version,
          value: item.rate
        }
      })
      this.$refs['ActiveProportionEachSystemVersion'].setEchartOption(
        ActiveProportionEachSystemVersionEchartOp({ v: this, data })
      )
    },
    setTeriBao (val) {
      this.ChinaMapLists[0][0].count = this.numberSplitWithComma(val.totalMac)
      this.ChinaMapLists[0][1].count = this.numberSplitWithComma(val.dailyMac)
      // 终端地1
      this.setChinaMapEchartOp(val.terminalMapList)
    },
    setChinaMapEchartOp (val = []) {
      let max = 0
      let data = val.map((item) => {
        max = Math.max(max, item.saturation)
        return {
          name: item.province,
          value: item.saturation
        }
      })
      this.$refs['ChinaMap'].setEchartOption(
        ChinaMapEchartOp({
          v: this,
          data: {
            data,
            max
          }
        })
      )
    }
  }
}
</script>

<style scoped lang="stylus">
.ResearchDevelopmentBulletinBoard {
  >>> {
    * {
      box-sizing: border-box;
      color: white;
    }
  }

  >>> {
    .font-size-text1 {
      font-size: 1rem;
    }

    .font-size-text07 {
      font-size: 0.7rem;
    }

    .font-size-text06 {
      font-size: 0.6rem;
    }
  }

  .left-wrap {
    height: 100%;

    .item {
      display: flex;

      .item-content+.item-content {
        margin-left: 1rem;
      }
    }

    .lists-items {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  .item-childe-item1 {
    // .item+.item
    // margin-top: 1.5rem
  }

  .floor1 {
    display: flex;
    margin-bottom: 0.8rem;

    .floor-item1 {
      flex-grow: 3;
      margin-right: 0.5rem;

      .floor-item1-wrap {
        padding: 0.5rem 1rem 1rem 1rem;
        display: flex;
        height: 250px;
        justify-content: space-between;
      }
    }

    .floor-item2 {
      flex-grow: 2;
      flex-basis: 32rem;

      >>> .title {
        font-size: 0.6rem;
      }
    }

    .item-childe-item2 {
      width: 15rem;
    }

    .box-item-title {
      margin-bottom: 0.5rem;
    }

    .item3-wrap {
      display: flex;
      height: 100%;

      .NetworkActivationAnalysis-wrap {
        flex-grow: 1;
        width: 12rem;
        margin-left: 1rem;
      }
    }

    .item-childe-item2, .item-childe-item3 {
      display: flex;
      flex-direction: column;
    }
  }
}

.item3-left-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  >>> {
    .title {
      font-size: 0.7rem;
      color: rgba(255, 255, 255, 0.6rem);
    }
  }
}

.floor-item2-wrap {
  padding: 1rem;
  display: flex;
  height: 250px;
  justify-content: space-between;

  >>> {
    .title {
      font-size: 0.7rem;
      color: rgba(255, 255, 255, 0.6rem);
    }
  }

  .right-wrap {
    display: flex;
    flex-grow: 1;
    margin-left: 0.5rem;
    justify-content: space-between;

    .liandong1-wrap, .liandong2-wrap {
      width: 13rem;
    }
  }
}

.floor2 {
  display: flex;
  margin-bottom: 0.8rem;

  .floor2-item1, .floor2-item2, .floor2-item3 {
    flex-grow: 1;
  }

  .floor2-item2, .floor2-item3 {
    margin-left: 0.5rem;
  }

  .floor2-item1, .floor2-item3 {
    width: 28rem;
  }

  .floor2-item1-wrap {
    height: 300px;
    display: flex;
    padding: 0.5rem;
    flex-wrap: wrap;

    >>> .title {
      font-size: 0.6rem;
      white-space: nowrap;
    }

    .item {
      display: flex;
      height: 140px;
      width: 50%;
      overflow: hidden;

      .item-left {
        flex: 1 1 auto;
      }

      .item-right {
        flex: 100 0 auto;
        height: 100%;
      }
    }
  }

  .floor2-item2-wrap {
    height: 300px;
    padding: 1rem;
    display: flex;
  }

  .f2-item2-left {
    >>> .title {
      font-size: 0.6rem;
      color: rgba(255, 255, 255, 0.6);
    }

    .lists-wrap {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
    }

    .item {
      display: flex;

      > div+div {
        margin-left: 0.5rem;
      }
    }
  }

  .f2-item2-right {
    height: 100%;
    flex-grow: 1;
    width: 15rem;
  }

  .floor2-item3-wrap {
    height: 300px;
    display: flex;
    padding: 0.5rem;
    flex-wrap: wrap;

    > .item {
      display: flex;
      width: 50%;
      height: 140px;
    }

    .f2-item3-left {
      .item {
        .content {
          >>> .title {
            color: rgba(255, 255, 255, 0.6);
            font-size: 0.6rem;
          }
        }
      }

      .f2-item3-left-title {
        margin-bottom: 0.4rem;
        font-size: 0.6rem;
        color: #fff;
        background-color: #457bd5;
        border-radius: 2rem;
        padding: 0.2rem 0.4rem;
        display: inline-block;
      }
    }
  }

  .floor2-item3-wrap {
    height: 300px;
    display: flex;

    .f2-item3-right {
      flex-grow: 1;
      width: 8rem;
    }
  }
}

.floor3 {
  display: flex;

  > div+div {
    margin-left: 0.5rem;
  }

  .floor3-content, .floor3-item3-wrap {
    height: 260px;
    display: flex;
  }

  .f3-item1-super {
    display: flex;
    font-size: 0.6rem;
    margin-left: 0.4rem;

    .super-hb {
      margin-left: 0.3rem;
    }
  }

  .f3-item1-bot {
    flex-grow: 1;
    width: 18rem;
  }

  .f3-item1-top, .f3-item2-top, .f3-item3-top {
    display: flex;
    justify-content: space-between;
  }

  .floor3-item2-wraps {
    display: flex;

    .f3-item2-bot {
      flex-grow: 1;
      display: flex;
      width: 18rem;
    }

    .f3-item2-item1, .f3-item2-item2 {
      display: flex;
      flex-direction: column;
    }

    .f3-item2-top-bug {
      margin-left: auto;
    }
  }

  .floor3-item3-box {
    flex-grow: 1;

    .f3-item3-bot {
      flex-grow: 1;
    }
  }

  .floor3-content {
    display: flex;
    padding: 1rem;
  }

  .floor3-item3-wrap {
    padding: 1rem;

    >div {
      flex-grow: 1;
    }

    .f3-item3-1 {
      width: 8rem;
    }

    .f3-item3-2 {
      width: 8rem;
    }
  }

  .floor3-item1-wrap {
    display: flex;
    flex-direction: column;
  }

  >>> {
    .container-box {
      display: flex;
      align-items: center;

      .title, .count {
        margin-bottom: 0;
      }

      .count, .super-count-wrap {
        margin-left: 0.4rem;
      }
    }
  }
}

.sb-titlte {
  color: #666;
  font-size: 0.1rem;
}
</style>
